import React from 'react';
import ReactDOM from 'react-dom';
import ReactOnRails from 'react-on-rails';

import ErrorBoundary from 'components/error_boundary';

export function unmountChildComponents(parentElement) {
  parentElement.querySelectorAll('.js-react-on-rails-component').forEach((element) => {
    const mountedElement = document.querySelector(`#${element.dataset.domId}`);
    if (mountedElement) {
      ReactDOM.unmountComponentAtNode(mountedElement);
    }
  });
}

export function registerWithErrorBoundary(components) {
  const errorBoundryWrapper = Object.fromEntries(
    Object.entries(components).map(([name, Component]) => {
      function ErrorBoundryWrapper(props) {
        return React.createElement(ErrorBoundary, null, React.createElement(Component, props));
      }

      return [name, ErrorBoundryWrapper];
    })
  );

  ReactOnRails.register(errorBoundryWrapper);
}
